import React, { Component } from 'react'; 

const Footer = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer id="footer-notice">
            <div className="container-fluid">
                <p>
                    AYESA ©{currentYear}
                </p>
            </div>
        </footer>
    );
}

export default Footer;